import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ProgramPanel from './programPanel';
import {
  bindSessions,
  unbind,
  createSession,
  updateSession,
  resetAddEditClassForm
} from 'actions/sessionActions';
import { updateProfile } from "actions/profileActions";
import * as programs from 'services/programs';

class ProgramsIndex extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      authData: PropTypes.shape({
        uid: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    sessions: PropTypes.object.isRequired,
    bindSessions: PropTypes.func.isRequired,
    unbind: PropTypes.func.isRequired,
    createSession: PropTypes.func.isRequired,
    updateSession: PropTypes.func.isRequired,
    resetAddEditClassForm: PropTypes.func.isRequired,
    updateProfile: PropTypes.func.isRequired
  };

  static contextTypes = {
    location: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired
  };

  componentDidMount () {
    const userId = this.props.auth.authData.uid;
    this.boundRefs = [];
    this.props.bindSessions(userId, this.boundRefs);
    dataLayer.push({ event: 'showChatWidget' });
  }

  componentWillUnmount () {
    this.props.unbind(this.boundRefs);
  }

  render () {
    const { auth, sessions } = this.props;
    const { authData } = auth;
    const { uid: userId } = authData;
    const { profile } = this.context;

    const featuredPrograms = programs.getFeaturedProgramsForProfile(profile);
    const programList = programs.getAvailableProgramsForProfile(profile);
    const otherPrograms = programList.filter(program => featuredPrograms.indexOf(program) < 0);

    return (
      <div>
        {featuredPrograms.length > 0 &&
        <div className="clearfix">
          {featuredPrograms.map(program => {
            const {id} = program;
            return (
              <ProgramPanel
                key={id}
                programs={featuredPrograms}
                program={program}
                userId={userId}
                sessions={sessions}
                createSession={this.props.createSession}
                updateSession={this.props.updateSession}
                resetAddEditClassForm={this.props.resetAddEditClassForm}
                updateProfile={this.props.updateProfile}/>
            );
          })}
        </div>
        }
        {featuredPrograms.length === 0 && otherPrograms.length > 0 &&
        <div className="clearfix">
          {otherPrograms.map(program => {
            const {id} = program;
            return (
              <ProgramPanel
                key={id}
                programs={programList}
                program={program}
                userId={userId}
                sessions={sessions}
                createSession={this.props.createSession}
                updateSession={this.props.updateSession}
                resetAddEditClassForm={this.props.resetAddEditClassForm}
                updateProfile={this.props.updateProfile}/>
            );
          })}
        </div>
        }
      </div>
    );
  }

}

export default connect(
  state => ({
    auth: state.auth,
    sessions: state.sessions
  }),
  {
    bindSessions,
    unbind,
    createSession,
    updateSession,
    resetAddEditClassForm,
    updateProfile
  }
)(ProgramsIndex);



// WEBPACK FOOTER //
// ./src/views/programs/index.jsx